import { cn } from "@/lib/utils";

/** İyzico işareti: menüde ve ödeme ekranında ödeme sağlayıcısını satış kanallarından ayırır. */
export function IyzicoMark({ className, title = "İyzico" }: { className?: string; title?: string }) {
  return (
    <svg viewBox="0 0 24 24" role="img" aria-label={title} className={cn("size-[18px] shrink-0", className)}>
      <title>{title}</title>
      <rect width="24" height="24" rx="6" fill="#1E64FF" />
      <circle cx="7.2" cy="7" r="1.7" fill="#fff" />
      <rect x="5.7" y="10" width="3" height="8.5" rx="1.5" fill="#fff" />
      <path d="M11 10.2h2.9l1.9 4.6 1.9-4.6h2.8l-4.6 10.1h-2.8l1.3-2.9z" fill="#fff" />
    </svg>
  );
}
